const swiperTimelineProgressive = {
    swiperInstance: null,
    swiperInstancePagination: null,

    init: () => {
        import('swiper/bundle').then(({Swiper}) => {

            let domEls = document.querySelectorAll('.js-swiper-timeline-progressive');
            // let domElsPagination = document.querySelectorAll('.js-swiper-timeline-progressive-pagination');
            let domElsPagination;

            if (domEls) {
                const paginationParams = getSwiperPaginationParams();
                const params = getSwiperParams();

                domEls.forEach(el => {

                    domElsPagination = el.nextElementSibling;

                    swiperTimelineProgressive.swiperInstancePagination = new Swiper(domElsPagination, paginationParams);   //NOSONAR
                    swiperTimelineProgressive.swiperInstance = new Swiper(el, params);   //NOSONAR

                    swiperTimelineProgressive.swiperInstance.controller.control = swiperTimelineProgressive.swiperInstancePagination
                    swiperTimelineProgressive.swiperInstancePagination.controller.control = swiperTimelineProgressive.swiperInstance

                })

            }
        })
    }
};

const getSwiperPaginationParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        speed: 500,
        a11y: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true
    };
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 32,
        slidesPerView: 1,
        speed: 500,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true
    }
}

export default swiperTimelineProgressive;